import { dashesToCamelCase } from "../utilities/globalUtilities";

export default () => {
    /**
    * Resets "modalsState" item from storage on load
    */
    $(window).on("load", () => {
        sessionStorage.removeItem("modalsState");
    });

    /**
    * Updates the state of every modal that was interacted with inside session storage
    */
    $("body").on("show.bs.modal shown.bs.modal hide.bs.modal hidden.bs.modal", ".modal", e => {
        const modalsState = sessionStorage.getItem("modalsState");
        const currentModalsState = modalsState ? JSON.parse(modalsState) : {};
        const modalId = dashesToCamelCase(e.currentTarget.id);

        currentModalsState[modalId] = e.type;

        sessionStorage.setItem("modalsState", JSON.stringify(currentModalsState));
    });
};
